export enum TenantDomainType {
    // CUDD = "localhost",
    CUDD = "cudd domain",
    TTS = "tts domain",
}
